export const legalnotice_website = `

# Acceptance License Agreement

This License Agreement (&quot;Agreement&quot;) is entered into by and
between the user (&quot;User&quot;) and Opensource.clinic
(&ldquo;Provider&rdquo;). By accessing the Website of the provider, the
user acknowledges and agrees to comply with the terms of this Agreement.
Please read this Agreement carefully before using the Website.

## 1. Purpose of the Website

The Website provides information about unofficial diabetes applications,
and the off-label use of medical devices which may pose potential risks to health. Although there are health
professionals at service, Opensource.clinic does not guarantee the
safety, efficacy, or legality of such applications. Using these
applications is at the user&#39;s own risk. We do not 
"treat" patients, we provide information and guidance for the use of
open-source software and hardware in diabetes management. 

## 2. User Acknowledgments

By using the Website, User acknowledges the following:

### 2.1 Unofficial Applications


  The Website may provide information about unofficial health applications
  that have not been verified or endorsed by healthcare authorities.
  Opensource.clinic disclaims any responsibility for the safety,
  efficacy, or legality of such applications.


### 2.2 Risks and Responsibilities


  User understands and accepts the potential risks associated with using
  unofficial open source diabetes applications. Opensource.clinic is not
  liable for any harm, damage, or consequences resulting from the use of
  such applications. Opensource.clinic is not liable for any harm, damage, 
  or consequences resulting from the use of off-label hardware


## 3. Acceptance of Terms


  By using the Website, User agrees to be bound by the terms and conditions
  of this Agreement. User further acknowledges that they have read and
  understood the content of the Website.


## 4. Website Content


  The content on the Website is subject to change without notice.
  Opensource.clinic does not guarantee the accuracy, completeness, or
  timeliness of the information provided.


`;
